import { render, staticRenderFns } from "./AffBlacklist.vue?vue&type=template&id=973aa0d0&scoped=true&"
import script from "./AffBlacklist.vue?vue&type=script&lang=js&"
export * from "./AffBlacklist.vue?vue&type=script&lang=js&"
import style0 from "./AffBlacklist.vue?vue&type=style&index=0&id=973aa0d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973aa0d0",
  null
  
)

export default component.exports